import http from './http';
import FPHTTP from './FP';
import FPHTTP2 from './FP2';

export const getMe = () => {
  return http.get('api/v1/users/profile').then(res => res.data);
};

export const login = (body) => {
  return http.post('api/v1/users/login', body).then(res => res.data);
};

export const getListUsers = (role, limit, offset) => {
  return http.get(`api/v1/users?role=${role}&limit=${limit}&offset=${offset}`).then(res => res.data);
};

export const getOrdersList = (offset) => {
  return http.get(`api/v1/orders?limit=200&offset=${offset}`).then(res => res.data);
};

export const getRiderHighBalances = (offset) => {
  return FPHTTP2.get(`/trips/high-earning`).then(res => res.data);
  //return FPHTTP.get(`/trips/active-drivers?tripId=${id}`).then(res => res.data);
};

export const getOrdersListReport = (offset) => {
  return http.get(`api/v1/orders?limit=500&offset=${offset}`).then(res => res.data);
};

export const getOrdersCount = () => {
  return http.get(`api/v1/orders/count-orders`).then(res => res.data);
};

export const getAllDishes = () => {
  return http.get(`api/v1/dishes`).then(res => res.data);
};

export const getAllBookings = () => {
  return http.get(`api/v1/bookings`).then(res => res.data);
};

export const deleteUser = (id) => {
  return http.delete(`api/v1/users/${id}`).then(res => res.data);
};

export const deleteOrder = (id) => {
  return http.delete(`api/v1/orders/${id}`).then(res => res.data);
};

export const deleteDish = (id) => {
  return http.delete(`api/v1/dishes/${id}`).then(res => res.data);
};

export const getProfitDetails = () => {
  return http.get(`/api/v1/financials/owner`).then(res => res.data);
};

export const updateUser = (id ,body) => {
  return http.put(`api/v1/users/${id}`, body).then(res => res.data);
};

export const updateUserbyadmin = (id ,body) => {
  return http.put(`api/v1/admin/${id}`, body).then(res => res.data);
};

export const uploadImage = async (file) => {
  const response = await http({
    method: "post",
    url: "/api/s3",
    data: file,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response;
};

export const getRegistrationForms = () => {
  return http.get(`/api/v1/users/registrations`).then(res => res.data);
};

export const getuserdetailsbyid = (id) => {
  return http.get(`/api/v1/admin/user/${id}`).then(res => res.data);
};

export const getAllGiftProducts = async (offset = 0, limit = 400) => {
  let nextOffset = offset;
  let response;
  const gifts = [];

  do {
    response = await http.get(`/api/v1/gifts?limit=${limit}&offset=${nextOffset}`);
    const page = response.data?.data?.Gifts || [];
    gifts.push(...page);
    nextOffset += page.length;
  } while (response.data?.data?.Gifts?.length === limit);

  return {
    ...response.data,
    data: {
      ...response.data.data,
      Gifts: gifts,
    },
  };
};

export const getDriverRegistrationForms = () => {
  return http.get(`/api/v1/users/drivers/forms`).then(res => res.data);
};

export const getAllEmployees = () => {
  return http.get(`/api/v1/employees`).then(res => res.data);
};

export const getAllGiftOrders = (limit, offset) => {
  return http.get(`/api/v1/giftorder?limit=${limit}&offset=${offset}`).then(res => res.data);
};

export const uploadImageWithoutSize = async (file) => {
  const response = await http({
    method: "post",
    url: "/api/withoutsize/s3",
    data: file,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response;
};

export const addDish = (body) => {
  return http.post(`/api/v1/dishes`, body).then(res => res.data);
};

export const addProduct = (body) => {
  return http.post(`/api/v1/gifts/add`, body).then(res => res.data);
};

export const getGiftById = (id) => {
  return http.get(`/api/v1/gifts/${id}`).then(res => res.data);
};

export const updateGiftProduct = (id, body) => {
  return http.put(`/api/v1/gifts/${id}`, body).then(res => res.data);
};

export const updateOrder = (id ,body) => {
  return http.put(`api/v1/orders/${id}`, body).then(res => res.data);
};

export const updateGiftOrder = (id ,body) => {
  return http.put(`api/v1/giftorder/${id}`, body).then(res => res.data);
};

export const getGiftOrderById = (id) => {
  return http.get(`api/v1/giftorder/${id}`).then(res => res.data);
};

export const deleteGiftProduct = (id) => {
  return http.delete(`api/v1/gifts/${id}`).then(res => res.data);
};

export const getActiveDrivers = (id) => {
  return FPHTTP.get(`/trips/active-drivers?tripId=${id}`).then(res => res.data);
};

export const markTripCompleted = (id) => {
  return FPHTTP.post(`/trips/completed-by-admin?tripId=${id}`).then(res => res.data);
};

export const updateWallet = (body) => {
  return FPHTTP.post(`/wallet/update`, body).then(res => res.data);
};


export const sendTirpByDriverId = (tripId, driverId) => {
  return FPHTTP.get(`/trips/broadcast-driver-by-id?tripId=${tripId}&driverId=${driverId}`).then(res => res.data);
};

export const assignTripByDriverId = (tripId, driverId) => {
  return FPHTTP.put(`/trips/assign-to-driver/${tripId}/${driverId}`).then(res => res.data);
};

export const getTripById = (tripId) => {
  return FPHTTP.get(`/trips/get-trip-details?tripId=${tripId}`).then(res => res.data);
};

export const getUserProfile = (id) => {
  return http.get(`api/v1/users/userProfile/${id}`).then(res => res.data);
};

export const broadcastTrip = (tripId) => {
  return FPHTTP.post(`/trips/broadcast-from-webhook?tripId=${tripId}`).then(res => res.data);
};

export const assignTrip = (tripId, driverId) => {
  return FPHTTP.post(`/trips/assign-trip-by-driver-id?tripId=${tripId}&driverId=${driverId}`).then(res => res.data);
};

export const getSingleOrder = (id) => {
  return http.get(`api/v1/orders/${id}`).then(res => res.data);
};

export const forgotPassword = (body) => {
  return http.post(`api/v1/users/forgot-password`, body).then(res => res.data);
};

export const changePassword = (body) => {
  return http.post(`api/v1/users/change-password`, body).then(res => res.data);
};